const route = [
  {
    path: '/discount',
    name: 'discount',
    component: () => import('@/views/other/discount'),
  },
  {
    path: '/restaurantList',
    name: 'restaurantList',
    component: () => import('@/views/other/restaurantList/index'),
  },
  {
    path: '/pizzaExpert',
    name: 'pizzaExpert',
    component: () => import('@/views/other/pizzaExpert'),
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/other/aboutUs'),
  },
  {
    path: '/club',
    name: 'club',
    component: () => import('@/views/other/club'),
  },
];

export default route;
